
    var riot = require('riot')
    //src: starling/src/tags/node-image-menu.html
riot.tag2('node-image-menu',
  '<ul class="menu-list"> <li ref="imageSizeMenuItem" onmouseenter="{openImageSizeMenu}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons">photo_size_select_large</i> <span>{this.isVideoMenu ? \'Video size\' : \'Image size\'}</span> <span class="container-right"> <i class="fa fa-caret-right"></i> </span> </li> <li onclick="{openEditImage}" if="{!this.isVideoMenu}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons">edit</i> <span>{this.isVideoMenu ? \'Edit video\' : \'Edit image\'}</span> </li> <li onclick="{downloadFile}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons">cloud_download</i> <span>{this.isVideoMenu ? \'Download video\' : \'Download image\'}</span> </li> <li onclick="{deleteImage}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons">delete</i> <span>{this.isVideoMenu ? \'Delete video\' : \'Delete image\'}</span> </li> </ul>',
  '',
  'ref="main" class="hidden" riot-style="{this.getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _appUi = require('lib/app-ui');

var _fileAttachmentsUi = require('lib/file-attachments-ui');

var _delayHandler = require('lib/delay-handler');

var _constants = require('lib/constants');

this.canvas = opts.canvas;
this.canvas.nodeImageMenu = this;
this.isOpen = false;
this.nodeTag = null;
this.menuName = 'node-image-menu';
this.isVideoMenu = false;

this.summon = function (_ref) {
  var nodeTag = _ref.nodeTag,
      referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      isVideoMenu = _ref.isVideoMenu,
      origin = _ref.origin;

  var rect = referenceEl.getBoundingClientRect();
  _this.nodeTag = nodeTag;
  _this.positionToLeft = positionToLeft;
  _this.origin = origin;
  _this.isVideoMenu = isVideoMenu;
  if (_this.fromOrigin('toolbar')) {
    _this.y = rect.bottom;
    _this.x = rect.left;
  } else {
    _this.y = rect.top;
    _this.x = rect.right;
    if (positionToLeft) {
      _this.x = window.innerWidth - rect.left;
    }
  }

  if (positionToLeft) {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; right: ' + _this.x + 'px';
  } else {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; left: ' + _this.x + 'px';
  }

  _this.refs.main.classList.add('visible');
  _this.refs.main.classList.remove('hidden');
  _this.nodeTag.setImageMenuToggleActive();
  _this.isOpen = true;
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.getStyle = function () {
  return _this.style;
};

this.hide = function () {
  if (_this.nodeTag) {
    _this.nodeTag.unsetImageMenuToggleActive();
  }
  _this.isOpen = false;
  _this.nodeTag = null;
  _this.origin = null;
  _this.selected = null;
  _this.isVideoMenu = false;
  if (_this.refs.main.classList.contains('visible')) {
    _this.refs.main.classList.remove('visible');
  }
  if (!_this.refs.main.classList.contains('hidden')) {
    _this.refs.main.classList.add('hidden');
  }
  _this.hideSubMenus();
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function (e) {
  canvas.imageSizeMenu.hide();
};

this.openImageSizeMenu = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'imagesize',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this._openImageSizeMenu(e);
    }
  });
};

this._openImageSizeMenu = function () {
  _this.hideSubMenus();
  canvas.imageSizeMenu.summon({
    referenceEl: _this.refs.imageSizeMenuItem,
    origin: _this.origin,
    nodeTag: _this.nodeTag,
    positionToLeft: _appUi.appUI.positionSubMenuToLeft({ positionReferenceElement: _this.refs.imageSizeMenuItem })
  });
};

this.openEditImage = function (e) {
  e.stopPropagation();
  _this.canvas.imageModal.triggerEdit(_this.nodeTag.id);
  _this.hide();
};

this.deleteImage = function () {
  _fileAttachmentsUi.fui.removeImage(_this.nodeTag.id);
  _this.hide();
};

this.downloadFile = function (e) {
  e.stopPropagation();
  window.open(_fileAttachmentsUi.fui.getFileUrl(_this.nodeTag.id), '_blank');
  _this.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-image-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-image-menu.html
// module id = 679
// module chunks = 0